<template>
  <div class="tag-template">
    <h3 class="tag-title">标签管理</h3>
    <div class="tag-content">
      <left-tree class="left" ref="leftTree" :innerHeight="innerHeight" @getTagList="getTagList" />
      <right-container class="right" :innerHeight="innerHeight" ref="rightContainer" />
    </div>
  </div>
</template>

<script>
import leftTree from './component/left-tree'
import rightContainer from './component/right-container'

export default {
  name: 'tagMgt',
  components: {
    leftTree,
    rightContainer
  },
  data() {
    return {
      projectOfferList: [],
      innerHeight: 0
    }
  },
  mounted() {
    this.setHeight()
  },
  beforeDestroy () {
    window.onresize = null
  },
  methods: {
    setHeight() {
      this.$refs.leftTree.setHeight(window.innerHeight)
      this.$refs.rightContainer.setHeight(window.innerHeight)
      window.onresize = () => {
        this.$refs.leftTree.setHeight(window.innerHeight)
        this.$refs.rightContainer.setHeight(window.innerHeight)
      }
    },
    getTagList(data = []) {
      this.$nextTick(() => {
        this.$refs.rightContainer.refreshTagList(data)
      })
    }
  }
}
</script>

<style scoped lang='less'>
.tag-template {
  .tag-title {
    font-size: 18px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    background-color: #049EA3;
  }
  .tag-content{
    width: 100%;
    background-color: #fff;
    .left,.right{
      display: inline-block;
      vertical-align: top;
    }
    .left{
      width: 240px;
    }
    .right{
      width: calc(100% - 240px);
    }
  }
}
</style>
